export default __webpack_public_path__ + "static/media/placeholder_dummy2016-diy01-mobile-de.7713bd3f.png";